import { all, fork, takeLatest } from 'redux-saga/effects';

import SessionApi from '@opendoor/shared-fe/build/api/session';
import SessionSaga from '@opendoor/shared-fe/build/store/session/saga';
import { COOKIE_KEY } from '../api';
import { RAILS_URL } from '../helpers/globals';
import agentResaleOfferPortalSaga from './agentResaleOfferPortal/saga';
import brokerageOfferFlowSaga from './brokerageOfferFlow/saga';
import homeProfileSaga from './homeProfile/saga';
import resaleClosingDashboardSaga from './resaleClosingDashboard/saga';

function* fixScroll() {
  if (typeof window !== 'undefined') {
    window.scrollTo(0, 0);
  }
}

function* appSaga() {
  yield all([takeLatest('@@router/LOCATION_CHANGE', fixScroll)]);
}

export default function* sagas() {
  yield all([
    fork(appSaga),
    fork(agentResaleOfferPortalSaga),
    fork(brokerageOfferFlowSaga),
    fork(homeProfileSaga),
    fork(resaleClosingDashboardSaga),
    fork(new SessionSaga(new SessionApi(COOKIE_KEY, RAILS_URL)).saga),
  ]);
}
